import React from 'react';

import { 
  Box, 
  Typography
} from '@mui/material';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import DiscountOutlinedIcon from '@mui/icons-material/DiscountOutlined';
import HubIcon from '@mui/icons-material/Hub';

import "../styles.scss";

const CoreCompany = ({
  navigate, 
  currentPage
}) => {
  return (
    <Box className="nav__side-common flex__Column" 
      display={"flex"} flexDirection={"column"} gap={"10px"}>
      <Box className="nav__side-container">
        <Box className={`nav__side-item flexCenter_Row`}
          onClick={() => {
            navigate("/business/core/companies");
          }}>
          <ArrowBackIcon />
          <Typography variant='body2'>
            Back
          </Typography>
        </Box>
        <Box className={`${currentPage === 0 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/core/companies/overview");
          }}>
          <HubIcon />
          <Typography variant='body2'>
            Overview
          </Typography>
        </Box>
        <Box className={`${currentPage === 1 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/core/companies/company-config");
          }}>
          <GroupOutlinedIcon />
          <Typography variant='body2'>
            Company Config
          </Typography>
        </Box>
      </Box>
      <Typography
        mt={"12px"}
        mb={"-5px"}>
        <i>Main</i>
      </Typography>
      <Box className="nav__side-container">
        <Box className={`${currentPage === 2 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/core/companies/employees");
          }}>
          <GroupOutlinedIcon />
          <Typography variant='body2'>
            Employees
          </Typography>
        </Box>
      </Box>

      <Typography
        mt={"12px"}
        mb={"-5px"}>
        <i>Banking</i>
      </Typography>
      <Box className="nav__side-container">
        <Box className={`${currentPage === 3 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/core/companies/bank-accounts");
          }}>
          <AccountBalanceOutlinedIcon />
          <Typography variant='body2'>
            Company Bank accounts
          </Typography>
        </Box>
      </Box>

      <Typography
        mt={"12px"}
        mb={"-5px"}>
        <i>Transactions</i>
      </Typography>
      <Box className="nav__side-container">
        <Box className={`${currentPage === 4 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/core/companies/transactions");
          }}>
          <AccountBalanceOutlinedIcon />
          <Typography variant='body2'>
            Transactions
          </Typography>
        </Box>
      </Box>

      <Typography
        mt={"12px"}
        mb={"-5px"}>
        <i>Blnk Config</i>
      </Typography>
      <Box className="nav__side-container">
        <Box className={`${currentPage === 5 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/core/companies/domestic-blnk-wallet");
          }}>
          <AccountBalanceWalletIcon />
          <Typography variant='body2'>
            Domestic Blnk Wallet
          </Typography>
        </Box>
         <Box className={`${currentPage === 6 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/core/companies/international-blnk-wallet");
          }}>
          <AccountBalanceWalletIcon />
          <Typography variant='body2'>
            International Blnk Wallet
          </Typography>
        </Box>
      </Box>

      <Typography
        mt={"12px"}
        mb={"-5px"}>
        <i>Billing</i>
      </Typography>
      <Box className="nav__side-container">
        <Box className={`${currentPage === 7 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/core/companies/billing");
          }}>
          <DiscountOutlinedIcon />
          <Typography variant='body2'>
            Billing
          </Typography>
        </Box>
      </Box> 
    </Box>
  )
}

export default CoreCompany;